import React from 'react';
import { CONFIG } from '../config';
import { useT } from '../i18n/LanguageContext';
export function Footer() {
  const {
    brand
  } = CONFIG;
  const t = useT().footer;
  return <footer className="border-t border-border py-12 mt-24" data-id="element-67">
      <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-68">
        <div className="font-['Archivo_Black'] text-lg uppercase tracking-tight" data-id="element-69">
          {t.brand1} <span className="text-brand" data-id="element-70">{t.brand2}</span>
        </div>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2" data-id="element-71">
          {[{
          label: t.links[0].label,
          url: brand.privacyUrl
        }, {
          label: t.links[1].label,
          url: brand.termsUrl
        }, {
          label: t.links[2].label,
          url: `mailto:${brand.supportEmail}`
        }].map(({
          label,
          url
        }) => <a key={label} href={url} className="font-mono text-xs text-ink-dim hover:text-brand transition-colors uppercase tracking-wider" data-id="element-72">
              {label}
            </a>)}
        </div>
        <p className="font-mono text-xs text-ink-dim" data-id="element-73">
          © {brand.year} {brand.name}
        </p>
      </div>
    </footer>;
}